import { FolderOpen, HardHat, Sprout, ClipboardList, CheckCircle, Banknote } from 'lucide-react';
import { formatBillionCurrency } from '@/utils/format';
import { KpiGrid, type KpiItem } from '@/components/ui/KpiGrid';
import type { ProjectSummary } from '../types/projects1.types';

interface ProjectStatsCardsProps {
  summary: ProjectSummary;
  isLoading: boolean;
}

export function ProjectStatsCards({ summary, isLoading }: ProjectStatsCardsProps) {
  const kpis: KpiItem[] = [
    {
      title: 'Tổng số dự án',
      value: summary.total || 0,
      suffix: 'Dự án',
      icon: FolderOpen,
      color: 'text-blue-600',
      bg: 'bg-blue-50',
      trend: 'neutral',
      trendValue: 'Toàn bộ',
      chartColor: 'bg-blue-500',
      chartData: [20, 25, 22, 30, summary.total || 35]
    },
    {
      title: 'Thi công',
      value: summary.construction || 0,
      suffix: 'Dự án',
      icon: HardHat,
      color: 'text-orange-600',
      bg: 'bg-orange-50',
      trend: 'up',
      trendValue: summary.total ? `${Math.round((summary.construction / summary.total) * 100)}%` : '0%',
      chartColor: 'bg-orange-500',
      chartData: [5, 8, 10, 12, summary.construction || 15]
    },
    {
      title: 'Bảo dưỡng',
      value: summary.maintenance || 0,
      suffix: 'Dự án',
      icon: Sprout,
      color: 'text-emerald-600',
      bg: 'bg-emerald-50',
      trend: 'up',
      trendValue: summary.total ? `${Math.round((summary.maintenance / summary.total) * 100)}%` : '0%',
      chartColor: 'bg-emerald-500',
      chartData: [2, 3, 4, 3, summary.maintenance || 5]
    },
    {
      title: 'Đang thực hiện',
      value: summary.active || 0,
      suffix: 'Dự án',
      icon: ClipboardList,
      color: 'text-indigo-600',
      bg: 'bg-indigo-50',
      trend: 'up',
      trendValue: summary.total ? `${Math.round((summary.active / summary.total) * 100)}%` : '0%',
      chartColor: 'bg-indigo-500',
      chartData: [10, 12, 15, 18, summary.active || 20]
    },
    {
      title: 'Đã hoàn thành',
      value: summary.completed || 0,
      suffix: 'Dự án',
      icon: CheckCircle,
      color: 'text-teal-600',
      bg: 'bg-teal-50',
      trend: 'up',
      trendValue: summary.total ? `${Math.round((summary.completed / summary.total) * 100)}%` : '0%',
      chartColor: 'bg-teal-500',
      chartData: [1, 2, 5, 8, summary.completed || 10]
    },
    {
      title: 'Tổng giá trị HĐ',
      value: formatBillionCurrency(summary.totalContract || 0),
      suffix: 'Tỷ',
      icon: Banknote,
      color: 'text-purple-600',
      bg: 'bg-purple-50',
      trend: 'up',
      trendValue: 'Triển khai',
      chartColor: 'bg-purple-500',
      chartData: [100, 120, 150, 180, 200]
    }
  ];

  return <KpiGrid kpis={kpis} />;
}
